import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import SendForm from './send_form';
import Wall from './wall';
import Loader from '../loader';

export default createReactClass({
  displayName: 'Root',
  PropTypes: {
    circleId: PropTypes.number.isRequired,
    currentUser: PropTypes.object.isRequired,
    isFormShow: PropTypes.bool,
  },
  getInitialState() {
    return {
      walls: [],
      loading: true,
      panelType: 'all',
    };
  },
  loadMyCircleWallsFromServer() {
    const isFormShow = this.props.isFormShow;
    $.ajax({
      url: '/api/my_circle/walls',
      type: 'GET',
      cache: false,
      data: {
        circle_id: this.props.circleId,
      },
    })
      .done(
        function (data) {
          var walls = data.walls;
          if (!isFormShow && walls.length > 4) {
            walls.splice(0, walls.length - 4);
          }
          this.setState({
            loading: false,
            walls: walls,
          });
          var target = $('#comment-area');
          $('html, body').scrollTop(target.height());
        }.bind(this)
      )
      .fail(
        function () {
          this.setState({
            loading: false,
          });
        }.bind(this)
      );
  },
  componentDidMount() {
    this.loadMyCircleWallsFromServer();
  },
  render() {
    const NoContents = () => {
      return (
        <div
          className="bg-graydark rounded p-2 d-flex align-items-center justify-content-center mt-1 mb-3 mx-auto"
          style={{ maxWidth: '312px' }}
        >
          <span className="text-black-50 text-fz-11px">削除された投稿</span>
        </div>
      );
    };

    const currentUser = this.props.currentUser;
    const isFormShow = this.props.isFormShow;
    const walls = this.state.walls.map(function (wall) {
      return (
        <div key={wall.id}>
          {wall ?
            wall.is_deleted ? (
                <NoContents />
              ) : (
                <Wall
                  wall={wall}
                  currentUser={currentUser}
                  isBodyShow={true}
                  isFormShow={isFormShow}
                />
            ) : ''
          }
        </div>
      );
    });
    return this.state.loading ? (
      <Loader isActive={this.state.loading} />
    ) : (
      <div className="pl-2">
        <div id="comment-area">
          <div className="pt-3 pb-0">
            {walls.length > 0 ? (
              <ul className="list-unstyled mb-0">{walls}</ul>
            ) : (
              <div
                className="pt-5"
                style={{ filter: 'grayscale(100%)', textAlign: 'center' }}
              >
                <img
                  src="/favicon.ico"
                  height="60px"
                  style={{ borderRadius: '50px' }}
                />
                <h6 className="text-gray text-fz-14px text-fw-bold pt-5 text-center">
                  サークルの主催者に質問することができます
                </h6>
                <p className="text-gray text-fz-11px text-center">
                  サークル参加にあたり不明なこと、不安なことを
                  <br />
                  主催者に質問しましょう。
                </p>
              </div>
            )}
          </div>
          <SendForm
            currentUser={currentUser}
            loadMyCircleWallsFromServer={this.loadMyCircleWallsFromServer}
            circleId={this.props.circleId}
            isFormShow={isFormShow}
          />
        </div>
      </div>
    );
  },
});
